export const styles = {
  sectionBackground: {
    backgroundColor: "#F5F8FF",
    textAlign: "center",
    paddingTop: { xs: "56px", sm: "120px" },
    paddingBottom: { xs: "56px", sm: "120px" },
  },
  publicationsRow: {
    justifyContent: "center",
    alignItems: "center",
    gap: 3,
  },
  cardsRow: {
    gap: 5,
    flexDirection: "column",
  },
  arrowButton: {
    "@media (max-width: 1300px)": {
      display: "none",
    },
  },
  arrowHidden: {
    visibility: "hidden",
    pointerEvents: "none",
  },
};
